import { FormEvent, useCallback, useState } from 'react';
import { formatDateToStr } from '../../../../../utils/format/formatDate';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Button } from '../../../../input/Button';
import { Input } from '../../../../input/Input';
import { Flex } from '../../../../layout/Flex';
import { FeedManagementDatePopupContentProps } from './types';

export const FeedManagementDatePopupContent: React.FC<FeedManagementDatePopupContentProps> = ({
    dateFrom: dateFromBase,
    dateTo: dateToBase,
    style,
    onChange,
}) => {
    const t = useTranslation();

    const maxDate = formatDateToStr(new Date());
    const [dateFrom, setDateFrom] = useState(dateFromBase || undefined);
    const [dateTo, setDateTo] = useState(dateToBase || undefined);

    const onDateFromInput = useCallback(
        (event: FormEvent<HTMLInputElement>) => {
            const max = dateTo || maxDate;
            const value = Date.parse(event.currentTarget.value);

            if (value > Date.parse(max)) {
                setDateFrom(max);

                return;
            }

            setDateFrom(event.currentTarget.value);
        },
        [dateTo, maxDate],
    );

    const onDateToInput = useCallback(
        (event: FormEvent<HTMLInputElement>) => {
            const min = dateFrom;
            const max = maxDate;
            const value = Date.parse(event.currentTarget.value);

            if (min && value < Date.parse(min)) {
                setDateTo(min);

                return;
            }

            if (value > Date.parse(max)) {
                setDateTo(max);

                return;
            }

            setDateTo(event.currentTarget.value);
        },
        [dateFrom, maxDate],
    );
    const onChangeDate = useCallback(() => {
        onChange(dateFrom, dateTo);
    }, [dateFrom, dateTo, onChange]);

    return (
        <Flex
            minWidth={250}
            maxWidth={{ sm: 360 }}
            width={{ xs: '100%', sm: 'auto' }}
            mt={{ sm: 1 }}
            position="relative"
            borderRadius={{ sm: 2 }}
            background="var(--background-primary)"
            boxShadow={{ sm: '0px 0px 4px 0px var(--control-primary-blur-background)' }}
            overflow="hidden"
            style={style}
        >
            <Flex
                width="100%"
                direction="row"
                px={{ sm: 3 }}
                pt={{ sm: 2 }}
                pb={{ xs: 3, sm: 2 }}
                spacing={1}
            >
                <Input
                    name="dateFrom"
                    variant="outline"
                    type="date"
                    lang="ru"
                    controlWidth="calc(50% - 4px)"
                    value={dateFrom}
                    max={dateTo || maxDate}
                    onChange={onDateFromInput}
                />
                <Input
                    name="dateTo"
                    variant="outline"
                    type="date"
                    lang="ru"
                    controlWidth="calc(50% - 4px)"
                    value={dateTo}
                    min={dateFrom}
                    max={maxDate}
                    onChange={onDateToInput}
                />
            </Flex>
            <Flex width="100%" direction="row" px={{ sm: 3 }} pb={2} spacing={1}>
                <Button width="100%" color="primary" size="l" onClick={onChangeDate}>
                    {t('Применить')}
                </Button>
            </Flex>
        </Flex>
    );
};
